import React from "react";
import Navbar from "./components/Navbar";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./components/Home";
import Reservations from "./components/Reservations";
import Adventure from "./components/Adventure";
import AdventureDetail from "./components/AdventureDetail";
import Footer from "./components/Footer";

const App = () => {
  return (
    <Router>
      <Navbar />
      <Switch>
        <Route path="/" exact>
          <Home />
        </Route>
        <Route path="/reservations" exact>
          <Reservations />
        </Route>
        <Route path="/adventure/:id" exact>
          <Adventure />
        </Route>
        <Route path="/adventure-detail/:id" exact>
          <AdventureDetail />
        </Route>
      </Switch>
      <Footer />
    </Router>
  );
};

export default App;
